export * from "./getters.js";
export * from "./actions.js";
export * from "./mutations";

export const HAPPINESS_TIPS_M = "HAPPINESS_TIPS/";
